export enum eLogLevel {
    Info = "INF",
    Debug = "DBG",
    Warn = "WRN",
    Error = "ERR"
  }